import { CLEAR_USED_GOODS, CLEAR_USED_GOODS_DETAIL, 
  GET_USED_GOODS_DETAIL_ERROR, GET_USED_GOODS_DETAIL_START, 
  GET_USED_GOODS_DETAIL_SUCCESS, GET_USED_GOODS_ERROR, GET_USED_GOODS_START, 
  GET_USED_GOODS_SUCCESS } from "../../actions/usedGoods";

const defaultState = {
  status: {
    started: false,      
    error: false,
    ended: false
  },
  list: [],
  drawer: null
};

export function usedGoods(state = defaultState, { type, payload }) {
  switch (type) {
  case CLEAR_USED_GOODS:
    return defaultState;
  case GET_USED_GOODS_START:
    return {
      ...state,
      status: {
        started: true,       
        error: false,
        ended: false
      }
    };
  case GET_USED_GOODS_ERROR:
    return {
      ...state,
      status: {
        started: false,       
        error: true,
        ended: false
      }
    };
  case GET_USED_GOODS_SUCCESS:
    return {
      ...state,
      status: {
        started: false,        
        error: false,
        ended: true
      },
      list: payload
    };
  case "UPDATE_USED_GOODS_DETAIL_SUCCESS":
    return {
      ...state,      
      list: payload
    };
  case GET_USED_GOODS_DETAIL_START:
    return {
      ...state,
      drawer:{
        status: {
          started: true,        
          error: false,
          ended: false
        },
        detail: null
      }
    };
    
  case GET_USED_GOODS_DETAIL_SUCCESS:
    return {
      ...state,
      drawer:{
        status: {
          started: false,        
          error: false,
          ended: true
        },
        detail: payload
      }
    };  
  case GET_USED_GOODS_DETAIL_ERROR:
    return {
      ...state,
      drawer:{
        status: {
          started: false,        
          error: true,
          ended: false
        },
        detail: null
      }
    };
  case CLEAR_USED_GOODS_DETAIL:
    return {
      ...state,
      drawer: null
    };
  default:
    return state;
  }
}
  
